import React, { PropsWithChildren } from 'react';

import ExperimentHeader from 'client/app/apps/disco-prototype/components/ExperimentHeader';
import FlexContainer from 'client/app/apps/disco-prototype/components/FlexContainer';

const Layout = ({ children }: PropsWithChildren) => {
  return (
    <FlexContainer direction="column">
      <ExperimentHeader
        title="ADP Glo Kinase Optimization"
        description="The ADP-Glo Kinase Assay is a homogeneous, bioluminescent assay used to measure kinase activity by quantifying the amount of ADP produced during a kinase reaction."
        creationDate="20th June, 2025"
      />
      {children}
    </FlexContainer>
  );
};

export default Layout;
